const trimTrailingSlash = (value) => String(value || "").trim().replace(/\/+$/, "");

// Deployments that predate REACT_APP_API_URL configure one full URL per endpoint;
// the server root is recovered from whichever of those is present.
const LEGACY_ENDPOINT_SUFFIX = /\/(?:submit|getarticles|track|login)$/i;

export const resolveApiBaseUrl = (environment = process.env) => {
  const configured = trimTrailingSlash(environment.REACT_APP_API_URL);
  if (configured) return configured;

  const legacyEndpoint = [
    environment.REACT_APP_CONTACT,
    environment.REACT_APP_GET_ARTICLES,
    environment.REACT_APP_COLLECTION,
    environment.REACT_APP_LOGIN,
  ]
    .map(trimTrailingSlash)
    .find((value) => LEGACY_ENDPOINT_SUFFIX.test(value));

  // An empty base keeps requests same-origin.
  return legacyEndpoint ? legacyEndpoint.replace(LEGACY_ENDPOINT_SUFFIX, "") : "";
};

export const API_BASE_URL = resolveApiBaseUrl();

const endpoint = (override, path) => trimTrailingSlash(override) || `${API_BASE_URL}${path}`;

const ARTICLE_ENGAGEMENT = endpoint(
  process.env.REACT_APP_ARTICLE_ENGAGEMENT,
  "/article-engagement"
);

export const API_ENDPOINTS = {
  login: endpoint(process.env.REACT_APP_LOGIN, "/login"),
  getArticles: endpoint(process.env.REACT_APP_GET_ARTICLES, "/getarticles"),
  getOneArticle: endpoint(process.env.REACT_APP_GET_ONE_ARTICLE, "/article"),
  postArticles: endpoint(process.env.REACT_APP_POST_ARTICLES, "/postarticles"),
  contact: endpoint(process.env.REACT_APP_CONTACT, "/submit"),
  messages: endpoint(process.env.REACT_APP_MESSAGES, "/messages"),
  androidApps: endpoint(process.env.REACT_APP_ANDROID_APPS, "/androidapps"),
  track: endpoint(process.env.REACT_APP_COLLECTION, "/track"),
  visitorSummary: endpoint(process.env.REACT_APP_VISITOR_SUMMARY, "/visitors/summary"),
  visitorAnalytics: endpoint(process.env.REACT_APP_VISITOR_ANALYTICS, "/visitors/analytics"),
  articleEngagement: ARTICLE_ENGAGEMENT,
  articleEngagementAnalytics:
    trimTrailingSlash(process.env.REACT_APP_ARTICLE_ENGAGEMENT_ANALYTICS) ||
    `${ARTICLE_ENGAGEMENT}/analytics`,
};
